<script>
    import FormRow from "../../components/FormRow.svelte";
    import FormColumn from "../../components/FormColumn.svelte";
    import LandingPage from "./LandingPage.svelte";
    import PersonalDetails from "./PersonalDetails.svelte";
    import ClaimDetails from "./ClaimDetails.svelte";

    import { projectSettings } from '../../config';
    import { pageNumber } from '../../stores';

    export let pageIndex = null;

    let disabled = true;

    pageNumber.update(p => pageIndex);

    document.title = `${projectSettings.classActionName} - Review`;
</script>

<section>

    <FormRow class="justify-content-center">
        <FormColumn>
            <h1 class="text-center">{@html projectSettings.classActionName}</h1>
        </FormColumn>
    </FormRow>

    <div class="confirmation">

        <LandingPage {disabled}></LandingPage>
        <PersonalDetails {disabled}></PersonalDetails>
        <ClaimDetails {disabled}></ClaimDetails>

    </div>

</section>
